var React = require('react');

var ReactDOM = require('react-dom');

var _ = require("underscore");

var SaleNotify = (props)=>
    props.role === 3
        ? <div className="mod-sale-notify">正在为用户{ props.uid } 计价</div>
        : <noscript/>

module.exports = SaleNotify;



/** WEBPACK FOOTER **
 ** ./script/detail/SaleNotify.jsx
 **/